module.exports = __webpack_public_path__ + "img/icon-package-lte-light.004a870.svg";